module.exports = __webpack_public_path__ + "assets/e0a3d98d4ce0aec5fb5467d79d34db91.png";